/* Specs Page — Model Toggle (Evolution / PRO) */
(function () {
  'use strict';

  var toggleBtns = document.querySelectorAll('.specs-toggle-btn');
  var panels = document.querySelectorAll('.specs-panel');

  if (!toggleBtns.length || !panels.length) return;

  toggleBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var model = this.dataset.model;

      toggleBtns.forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');

      panels.forEach(function (panel) {
        if (panel.id === 'sp-' + model) {
          panel.classList.add('active');
        } else {
          panel.classList.remove('active');
        }
      });
    });
  });
})();
